import { render, staticRenderFns } from "./root-medicine-order-details.vue?vue&type=template&id=ac2998b6&scoped=true"
import script from "./root-medicine-order-details.vue?vue&type=script&lang=js"
export * from "./root-medicine-order-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2998b6",
  null
  
)

export default component.exports